import { render, staticRenderFns } from "./ModificarPrecioExamenComuna.vue?vue&type=template&id=5d477c20&scoped=true&"
import script from "./ModificarPrecioExamenComuna.vue?vue&type=script&lang=js&"
export * from "./ModificarPrecioExamenComuna.vue?vue&type=script&lang=js&"
import style0 from "./ModificarPrecioExamenComuna.vue?vue&type=style&index=0&id=5d477c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d477c20",
  null
  
)

export default component.exports